import { render, staticRenderFns } from "./trc.vue?vue&type=template&id=9fcb3e96"
import script from "./trc.vue?vue&type=script&lang=js"
export * from "./trc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports